import { Product } from './products'

/**
 * Pool chemicals currently listed in the Pegasus online catalog.
 * An empty `image` renders the shared "Product image not available." placeholder.
 */
export const poolChemicalProducts: Product[] = [
  {
    name: 'Pool Magnet Plus',
    sku: '20356',
    price: 24.99,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Super Soluble Sanitizer 5#',
    sku: '20295',
    price: 60.89,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Stow-A-Way Cleaner',
    sku: '13591',
    price: 14.25,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Standard Leaf Skimmer Net',
    sku: '14476',
    price: 7.2,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Sparkle Up 1.5#',
    sku: '15334',
    price: 39.99,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Solar Duck Chlorinator',
    sku: '14812',
    price: 39.99,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/solar%20duck.jpg',
    alt: 'Solar Duck floating pool chlorinator',
  },
  {
    name: 'Smart Shock 2# Bottle',
    sku: '13689',
    price: 19.99,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
  {
    name: 'Smart Shock 1# Bag',
    sku: '13688',
    price: 9.65,
    availability: 'In Stock',
    image: '',
    alt: '',
  },
]
